import { render, staticRenderFns } from "./CategoryDetail.vue?vue&type=template&id=d8a67e54&scoped=true"
import script from "./CategoryDetail.vue?vue&type=script&lang=js"
export * from "./CategoryDetail.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetail.vue?vue&type=style&index=0&id=d8a67e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a67e54",
  null
  
)

export default component.exports